import { render, staticRenderFns } from "./vTrialEndUpsellModal.vue?vue&type=template&id=01130b19&scoped=true"
import script from "./vTrialEndUpsellModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vTrialEndUpsellModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01130b19",
  null
  
)

export default component.exports